/**
 * Keyboard access for scrolling table containers (WCAG 2.1.1 / axe scrollable-region-focusable).
 * Design-system tables render inside `.ex-tablewrap` with overflow:auto; when the content actually scrolls,
 * the container becomes a labelled, focusable region so keyboard users can scroll it. Non-scrolling
 * containers get no extra tab stop.
 */
const SELECTOR = '.ex-tablewrap, .ex-tablebox';
const MARK = 'data-ex-scrollfocus';

function update(el: HTMLElement) {
  const scrolls = el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1;
  if (scrolls && !el.hasAttribute('tabindex')) {
    el.setAttribute('tabindex', '0');
    el.setAttribute(MARK, '');
    if (!el.getAttribute('role')) el.setAttribute('role', 'region');
    if (!el.getAttribute('aria-label')) {
      const cap = el.querySelector('caption')?.textContent?.trim();
      el.setAttribute('aria-label', cap ? `${cap} (scrollable)` : 'Scrollable table');
    }
  } else if (!scrolls && el.hasAttribute(MARK)) {
    el.removeAttribute('tabindex');
    el.removeAttribute(MARK);
  }
}

export function installScrollableRegions() {
  let raf = 0;
  const run = () => {
    raf = 0;
    document.querySelectorAll<HTMLElement>(SELECTOR).forEach(update);
  };
  const schedule = () => {
    if (!raf) raf = requestAnimationFrame(run);
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', schedule);
  schedule();
}
